import React from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ConversationListItem } from "./ConversationListItem";
import { EmptyConversationsState } from "./EmptyConversationsState";
import { ConversationListHeader } from "./ConversationListHeader";
import { ConversationListSkeleton } from "./ConversationListSkeleton";
import { useConversations } from "../../hooks/useConversations";

interface ConversationListProps {
  onSelectConversation: (id: string) => void;
  activeConversationId?: string;
}

export function ConversationList({ 
  onSelectConversation, 
  activeConversationId 
}: ConversationListProps) {
  const { conversations, loading, error } = useConversations();
  
  if (loading) return <ConversationListSkeleton />;
  
  if (error) {
    return (
      <div className="flex flex-col h-full border-r border-border bg-background">
        <ConversationListHeader />
        <div className="flex-1 flex items-center justify-center p-4">
          <div className="text-center">
            <p className="text-sm text-muted-foreground">Error loading conversations</p>
            <p className="text-xs text-muted-foreground mt-1">{error.message}</p>
          </div>
        </div>
      </div>
    );
  }
  
  if (!conversations.length) {
    return (
      <div className="flex flex-col h-full border-r border-border bg-background">
        <ConversationListHeader />
        <EmptyConversationsState />
      </div>
    );
  }
  
  return (
        <div className="flex flex-col h-full border-r border-border bg-background" data-slot="conversation-list">
      <ConversationListHeader />
            <ScrollArea className="flex-1 overflow-hidden">
        <div className="p-2 space-y-1">
          {conversations.map((conversation) => (
            <ConversationListItem
              key={conversation.id}
              conversation={conversation}
              isActive={conversation.id === activeConversationId}
              onClick={() => onSelectConversation(conversation.id)}
            />
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}